/**
 * GENERATED FILE — DO NOT EDIT.
 * Run `pnpm a2a-contract:generate` after changing the
 * canonical Pydantic contract.
 */
export const CONTRACT_VERSION = 1 as const;
export const OPERATOR_STEP_SCHEMA_VERSION = 1 as const;
export type OperatorStepSchemaVersion = typeof OPERATOR_STEP_SCHEMA_VERSION;
export const contractSchemaId =
  "https://gently.com/contracts/a2a/v1/schema.json" as const;
export const contractRevision =
  "909a259e03caaffdf3f205c7a411ac03d8578982963b970e0ebff3902132544e" as const;
export const contractManifest = {
  common: {
    aiAttribution: "AiAttribution",
    contractMetadata: "ContractMetadata",
    operatorStep: "OperatorStep",
    runError: "RunError",
    sopBranch: "SopBranch",
    sopParam: "SopParam",
    sopStep: "SopStep",
    taskRef: "TaskRef",
    usageTagNamespace: "UsageTagNamespace",
  },
  contractVersion: 1,
  revision: "909a259e03caaffdf3f205c7a411ac03d8578982963b970e0ebff3902132544e",
  schema: "https://gently.com/contracts/a2a/v1/schema.json",
  skills: {
    "mock_ui.studio": {
      artifact: "MockUiStudioArtifact",
      description:
        "Builds and iterates on a static mock UI in an isolated sandbox, with typed preview pauses, edited files, a state graph, and evaluation paths.",
      input: "MockUiStudioInput",
      inputModes: ["text/plain", "application/json", "image/png"],
      name: "Mock UI Studio",
      output: "MockUiStudioOutput",
      outputModes: ["text/plain", "application/json", "image/png"],
      pause: "MockUiStudioPause",
      resumable: true,
      resume: "MockUiStudioResume",
      signal: "MockUiStudioSignal",
      tags: ["mock-ui", "sandbox", "coding", "human-in-the-loop"],
    },
    "operator.author_sop": {
      artifact: "AuthorSopArtifact",
      description:
        "Co-authors a structured, replayable SOP with a human and supports annotations, takeover, free-roam capture, phases, and alternate paths.",
      input: "AuthorSopInput",
      inputModes: ["text/plain", "application/json", "image/png"],
      name: "SOP Author",
      output: "AuthorSopOutput",
      outputModes: ["text/plain", "application/json", "image/png"],
      pause: "AuthorSopPause",
      resumable: true,
      resume: "AuthorSopResume",
      signal: "AuthorSopSignal",
      tags: ["browser", "sop", "authoring", "human-in-the-loop"],
    },
    "operator.browser_use": {
      artifact: "BrowserUseArtifact",
      description:
        "Drives a caller-provided browser to complete a natural-language task, streaming redacted reasoning, actions, screenshots, and typed results.",
      input: "BrowserUseInput",
      inputModes: ["text/plain", "application/json"],
      name: "Browser Operator",
      output: "BrowserUseOutput",
      outputModes: ["text/plain", "application/json", "image/png"],
      pause: "BrowserUsePause",
      resumable: true,
      resume: "BrowserUseResume",
      signal: "BrowserUseSignal",
      tags: ["browser", "automation", "computer-use", "session-rules-v1"],
    },
    "operator.run_sop": {
      artifact: "RunSopArtifact",
      description:
        "Replays a flattened SOP deterministically, self-heals drift, records branch decisions, and returns persistable repairs and complete tallies.",
      input: "RunSopInput",
      inputModes: ["text/plain", "application/json"],
      name: "SOP Replay",
      output: "RunSopOutput",
      outputModes: ["text/plain", "application/json", "image/png"],
      pause: null,
      resumable: false,
      resume: null,
      signal: "RunSopSignal",
      tags: ["browser", "sop", "replay", "self-healing", "session-rules-v1"],
    },
  },
} as const;
